import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import React from "react";


const TextImage = ({ blok }) => (
  <div className="wrap">
    <div
      className="textimage-wrap flex inner-wrap"
      {...storyblokEditable(blok)}
    >
      <div className="textimage-content flex flex-col">
        <h2 className="text-3xl">{blok.subheadline}</h2>
        <div className="textimage-img ml-8">
          <img
            style={{ display: `${blok.hideImage}` }}
            className="hide-mobile pb-4"
            src={blok.image.filename}
            alt="img"
          />
          <div style={{ display: `${blok.hideVideo}` }} className="textimage-iframe-mobile-outer hide-mobile">
            <iframe
              style={{ display: `${blok.hideVideo}` }}
              className="textimage-iframe-mobile"
              src={blok.video}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="PA_Akquisefilm V22"
            ></iframe>
          </div>
        </div>
        <p>{blok.text}</p>

        <div
          className="textimagebutton-wrap"
          style={{ display: `${blok.flex}` }}
          {...storyblokEditable(blok)}
        >
          {blok.link && (
            <Link href={blok.link} >
              <button className="button-default-width">{blok.button}</button>
            </Link>
          )}
          {blok.linknewtab && (
            <Link target="_blank" href={blok.linknewtab} >
                <button className="button-default-width">
                  {blok.buttonnewtab}<br></br>
                  {blok.buttonnewtabNextRow}

                </button>
            </Link>
          )}
        </div>

        <div
          className="textimagebutton-wrap"
          style={{ display: `${blok.flex}` }}
          {...storyblokEditable(blok)}
        >
          {blok.linkTwo && (
            <Link href={blok.linkTwo} >
              <button className="button-default-width">{blok.buttonTwo}</button>
            </Link>
          )}
          {blok.buttonnewtabTwo && (

            <Link
              target="_blank"
              download
              href="../files/Save the date 20. Gastronomieforum München 2025.ics"              
              >
                <button className="button-default-width">
                {blok.buttonnewtabTwo}
                </button>
            </Link>
          )}

        </div>

        <div
          className="textimagebutton-wrap"
          style={{ display: `${blok.flex}` }}
          {...storyblokEditable(blok)}
        >
          {blok.linkThree && (
            <Link href={blok.linkThree} >
              <button className="button-default-width">{blok.buttonThree}</button>
            </Link>
          )}
          {blok.linknewtabThree && (
            <Link target="_blank" href={blok.linknewtabThree} >
                <button className="button-default-width">
                  {blok.buttonnewtabThree}<br></br>
                  {blok.buttonnewtabNextRowThree}

                </button>
            </Link>
          )}
        </div>

        {/* <div>
          <button>{blok.button}</button>  
        </div> */}
      </div>
      <div className="textimage-img ml-8">
        <img
          style={{ display: `${blok.hideImage}` }}
          className="hide-desktop"
          src={blok.image.filename}
          alt="img"
        />
        <iframe
          style={{ display: `${blok.hideVideo}` }}
          className="hide-desktop textimage-iframe"
          src={blok.video}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="PA_Akquisefilm V22"
        ></iframe>
      </div>
    </div>
  </div>
);

export default TextImage;
